$(document).ready(function(){
  $(document).on('click', '.addCart', function(e){

    // $(".addCart").click(function(e){
    e.preventDefault();
    var pro_id = $(this).data('id'); 
    var bt = $(this);
    // alert(pro_id);
    var cart_varid=[];
    // console.log(pro_id);
    $.getJSON("/cart", function(result){
      var pro=result.items;
      $.each(pro, function (index, value) {
        cart_varid.push(value.id);
      });

      // console.log('array value'+cart_varid);

      if($.inArray(pro_id, cart_varid) > -1){

        alert("No more than one!!!");
        //console.log("pro duct in cart page");
        return false;
      }
      else{
        // alert('add successfully!!!');
        //console.log("product is not in cart page");

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: {
            id: pro_id,
            quantity: 1,

          },   

          beforeSend:function() {    
            bt.find(".aftersend").removeClass("hide");
          },
          success: function(pro_id){ 


            //         show successfull msg
            bt.parent('.cart-popup-item').find(".aftersuccess").removeClass("bdone");   

            //         hide msg after few time       
            setTimeout(fade_out, 1000);                
            function fade_out() {       
              bt.parent('.cart-popup-item').find(".aftersuccess").fadeOut();    
            };

            //         for loader       
            bt.find(".aftersend").addClass("hide");

            $.ajax({
              type: 'GET',
              dataType: 'json',
              url: '/cart.js',
              success:function(cart){

                var cartpag=cart.items;
                var html='';
                console.log(cart.items);
                $.each(cartpag, function(index,item ){                    
                  var producttitle = item.product_title;
                  var img = item.featured_image.url;
                  var quantity=item.quantity;
                  var price=item.final_price;
                  var totalprice=item.total_price;
                  var variantid=item.id;
                  console.log(variantid);
                  html +='<div class="mainp"><h1 class="hids" data-id='+variantid+'>remove <div class="maind"><p>'+producttitle +'</p><img src="' + img + '"><p>Rs ' + price/(100) +'</p></div></h1></div>' ;
                });
                $('#ajaximgdesc').html(html);
                $('#totalpri').html(cart.total_price/(100));
                $('#totalpri').html(cart.total_price/(100));
                $('#CartCo').html(cart.item_count);    
                $('#CartCount').html(cart.item_count);               
                window.scrollTo({});

                $('.hids').click(function(){
                  var c = $(this);                              
                  var varid = $(this).data("id");
                  console.log(varid)
                  jQuery.ajax({ 
                    type: 'POST',
                    url: '/cart/change.js',
                    data:{
                      id: varid,
                      quantity: 0,
                    },
                    dataType: 'json',
                    success:function(){
                      c.hide();
                      $('#totalpri').html(cart.total_price/(100));
                      $('#totalpri').html(cart.total_price/(100));

                      $('#CartCo').html(cart.item_count);    
                      $('#CartCount').html(cart.item_count);   
                    }

                  });

                }); 
              } 
            });
          },
        });
      }
    });
  });
});


// add only single product 

// $(document).ready(function() {
//    $('.addCart').click(function(){
//       var id = $(this).data('id');
//         console.log(id);

//        $.ajax({
//           type: 'POST',
//           dataType: 'json',  <div class="btn-filter">
//           url: '/cart.js',
//            dataType: 'json',
//      success: function(cart){ 
//                    var cartpag=cart.items;

//          $.each(cartpag, function(index,item ){                    
//            cartpag=[cart.items];
//            console.log(cartpag);
//               var quantity=item.quantity;
//               console.log(quantity);

//              if   (quantity > 1){
//                    console.log(quantity);
//                    alert("one product already added !!");
// //              }
// //                  else if (quantity < 1){
// //                   event.preventDefault();
// //                    alert("Only one product add!!!");

//                  }else {
//                                <div class="btn-filter"> }
// //               html +='<div class="mainp"><h1 class="hids" data-id='+variantid+'>remove <div class="maind"><p>'+producttitle +'</p><img src="' + img + '"><p>Rs ' + price/(100) +'</p></div></h1></div>' ;
// //             });
// //             $('#ajaximgdesc').html(html);    
// });
//    }
//       });  
//         });
//          });



$(".cart-popup__close").click(function()
                              {
  $(".custom1popup_cart").addClass("hidenajax");
});

$('.varremove').click(function(){  

  $(".mainajaxdata").addClass("sh");
});

$(".cart-popup-item").click(function()  {
  $(".custom1popup_cart ").removeClass("hidenajax")  ;                    
});
$(".cart-popup__close").click(function()  {
  $(".custom1popup_cart ").addClass("hidenajax")  ;                    
});

//         for variant button click

$(document).on('click', '.addCart', function(){
  $(".custom1popup_cart ").removeClass("hidenajax")  ;                    
});

// $(".m").click(function()  {
//   $(".mainp").hide()  ;                    
// });

// <div class='mainp'><button class='m'>remove</button>$(".m").click(function()  {



$(".hids").click(function()  { 
  $(".mainp").hide()  ;                    
});




// $(document).ready(function() {
//   $('.addCart').click(function(){
//     var element=$(this);
//     var fetchdata = $(this).data('id');   
//     jQuery.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       dataType: 'json',
//       data: {
//         id: fetchdata,
//         quantity: 1,

//       },   

//       beforeSend:function() {    
//         element.find(".aftersend").removeClass("hide");
//       },
//       success: function(fetchdata){ 



//         //         show successfull msg
//         element.parent('.cart-popup-item').find(".aftersuccess").removeClass("bdone");   

//         //         hide msg after few time       
//         setTimeout(fade_out, 1000);                
//         function fade_out() {       
//           element.parent('.cart-popup-item').find(".aftersuccess").fadeOut();    
//         };

//         //         for loader       
//         element.find(".aftersend").addClass("hide");

//         $.ajax({
//           type: 'GET',
//           dataType: 'json',
//           url: '/cart.js',
//           success:function(cart){

//             var cartpag=cart.items;
//             var html='';
//             console.log(cart.items);
//             $.each(cartpag, function(index,item ){                    
//               var producttitle = item.product_title;
//               var img = item.featured_image.url;
//               var quantity=item.quantity;
//               var price=item.final_price;
//               var totalprice=item.total_price;
//               var variantid=item.id;
//               console.log(variantid);
//               html +='<div class="mainp"><h1 class="hids" data-id='+variantid+'>remove <div class="maind"><p>'+producttitle +'</p><img src="' + img + '"><p>Rs ' + price/(100) +'</p></div></h1></div>' ;
//             });
//             $('#ajaximgdesc').html(html);
//             $('#totalpri').html(cart.total_price/(100));
//             $('#totalpri').html(cart.total_price/(100));
//             $('#CartCo').html(cart.item_count);    
//             $('#CartCount').html(cart.item_count);               
//             window.scrollTo({});

//             $('.hids').click(function(){
//               var c = $(this);                              
//               var varid = $(this).data("id");
//               console.log(varid)
//               jQuery.ajax({ 
//                 type: 'POST',
//                 url: '/cart/change.js',
//                 data:{
//                   id: varid,
//                   quantity: 0,
//                 },
//                 dataType: 'json',
//                 success:function(){
//                   c.hide();
//                   $('#totalpri').html(cart.total_price/(100));
//                   $('#totalpri').html(cart.total_price/(100));

//                   $('#CartCo').html(cart.item_count);    
//                   $('#CartCount').html(cart.item_count);   
//                 }

//               });



//             $(document).on('click','.varremove',function(){
//               var c=$(this);This site uses cookies. By continuing to browse the site, you are agreeing to our 
//               var varid = $(this).data('id');
//               console.log(varid);
//               jQuery.ajax({ 
//                 type: 'POST',
//                 url: '/cart/change.js',
//                 data:{
//                   id: varid,
//                   quantity: 0,
//                 },
//                 dataType: 'json',
//                 success:function(){
//                   $.ajax({
//                     type: 'GET',
//                     dataType: 'json',
//                     url: '/cart.js',
//                     success:function(cart){
//                       var cartLength=Object.keys(cart.items).length;
//                       if(cartLength>0)
//                       {
//                         console.log(cart.items);
//                         var items = cart.items;
//                         var empty= '';
//                         var count=cart.item_count;-
//                           items.forEach(function(item){           
//                           var variantid=item.id;
//                           var img=item.featured_image.url;
//                           var title=item.product_title;
//                           var quantity=item.quantity;             
//                           var vartitle=item.variant_title;
//                           var price=item.price;
//                           console.log(variantid);
//                           empty += "<div class='mainajaxdata' id='ajaximgdesc'><div class='minicartimage'><img id='minicartimage' src='" + img + "'></div><div class='varremove' data-id='"+ variantid +"'><a>Remove item</a></div><div class='customajaxquantity'>Qty(" + quantity +")</div><div class='customminititle'>" + title + "(" + vartitle + ")</div><div>Item Price="+price/(100) +"</div></div>";
//                           //             console.log(empty);
//                           $('.appenddata').html($(empty));
//                           $('#vprice').html("Total Price=" + cart.total_price/(100));
//                           $('#ajaxdata').html("<p class='customminiviewcart'>view cart(" + count + ")</p></div>");
//                           //  window.scrollTo({top: 0, behavior: 'smooth'});
//                         });-
//                       }
//                       else
//                       {
//                         $('.appenddata').html('Cart is empty');
//                         $('#vprice').html("");
//                         $('#ajaxdata').html("");

//                       }
//                     }
//                   });
//                 }
//               }); 
//             }); 


//           

//             });    



//           }

//         });
//       }
//     });
//   });
// });

//       error: function(){
//         alert( "please add another product" );
//       }




$(document).ready(function() {
  $(".btnclose").click(function(){
    $(".popup-overlay").hide(); 
  });
});
$(document).click(function(event) {
  //   console.log(event.target.id =='');
  if(event.target.id =='ac-wrapper')
  {
    $(".popup-overlay").hide(); 
  }
  else
  {
  }

});


// jQuery(document).ready(function($) {

//   //check to see if the submited cookie is set, if not check if the popup has been closed, if not then display the popup
//   if( getCookie('popupCookie') != 'submited'){ 
//     if(getCookie('popupCookie') != 'closed' ){
//         $(".btnclose").click(function(){
//     $(".popup-overlay").hide(); 
//    });
//     }


//   $('.btnclose').click(function(){
//     $('.popup-overlay').fadeOut();
//     //sets the coookie to one minute if the popup is closed (whole numbers = days)
//     setCookie( 'popupCookie', 'closed', .00069444444 );
//   });

//   $('.sub').click(function(){
//     $('.popup-overlay').fadeOut();
//     //sets the coookie to five minutes if the popup is submited (whole numbers = days)
//     setCookie( 'popupCookie', 'submited', .0034722222 );
//   });



// };
// });

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}


// code for infinite scroll

function ScrollExecute() {

  if(!isActive && $(document).height() - 800 < ($(document).scrollTop() + $(window).height())) {

    isActive = true;

    var scrollNode = $('#more').last();

    var scrollURL = $('#more p a').last().attr("href");

    if(scrollNode.length > 0 && scrollNode.css('display') != 'none') {
      console.log(scrollNode);
      console.log(scrollURL);

      $.ajax({

        type: 'GET',

        url: scrollURL,

        beforeSend: function() {

          scrollNode.clone().empty().insertAfter(scrollNode).append('LOADING MORE PRODUCTS');

          scrollNode.hide();

        },

        success: function(data) {

          // remove loading feedback

          scrollNode.next().remove();

          var filteredData = $(data).find(".product");

          filteredData.insertBefore( $("#product-list-foot") );

          isActive = false;

        },

        dataType: "html"

      });

    }

  }

}

var isActive = false;

$(document).ready(function () {

  $(window).scroll(function(){
    setTimeout(ScrollExecute, 200);
    console.log(ScrollExecute);
    // $.doTimeout( 'scroll', 200, ScrollExecute);

  });

});


// country flag js

jQuery(document).ready(function(){
  var windowWidth=jQuery(window).width();


  $(".desktop-flag").click(function(e){       
    e.stopPropagation();
    $(".desktop-flag-ul").toggleClass('activeFlag');
    $("body").click(function(e){
      if(e.target.id != "desktop-flag-ul")
      {
        $(".desktop-flag-ul").removeClass('activeFlag');
        $("body").unbind("click");
      }
    });
  });
});









